import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import React, { PureComponent } from 'react';
export default function createToolbarAndroidComponent(IconNamePropType, getImageSource) {
  return function (_PureComponent) {
    _inherits(IconToolbarAndroid, _PureComponent);

    function IconToolbarAndroid() {
      _classCallCheck(this, IconToolbarAndroid);

      return _possibleConstructorReturn(this, _getPrototypeOf(IconToolbarAndroid).apply(this, arguments));
    }

    _createClass(IconToolbarAndroid, [{
      key: "render",
      value: function render() {
        return null;
      }
    }]);

    return IconToolbarAndroid;
  }(PureComponent);
}